import React, { FC } from 'react'
import { useTheme } from '@shared/lib'

const HomeIcon: FC = () => {
  const theme = useTheme()

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.5001 21C12.8438 21 13.1956 20.9898 13.5504 20.9715C15.5249 20.8697 16.5121 20.8188 17.5871 20.1688C18.2626 19.7604 19.0332 18.949 19.4063 18.2533C20.0001 17.1463 20.0001 15.9309 20.0001 13.5C21.2537 13.3209 21.8805 13.2314 22.1763 12.8729C22.3395 12.6753 22.4373 12.4219 22.4495 12.1659C22.4714 11.7017 22.0721 11.2195 21.2734 10.255C20.4554 9.26729 19.4868 8.11971 18.5001 7C18.1632 6.61773 17.8381 6.23871 17.5223 5.8704C15.7116 3.75911 14.203 2 12.5001 2C10.7971 2 9.2885 3.75911 7.47785 5.8704C7.16199 6.23871 6.83694 6.61773 6.50006 7C5.51331 8.11971 4.54468 9.26729 3.7267 10.255C2.92803 11.2195 2.52869 11.7017 2.55066 12.1659C2.56278 12.4219 2.66065 12.6753 2.82378 12.8729C3.11957 13.2314 3.7464 13.3209 5.00004 13.5C5.00004 15.9308 5.00006 17.1463 5.59377 18.2533C5.96689 18.949 6.73749 19.7604 7.41304 20.1688C8.48801 20.8188 9.47525 20.8697 11.4497 20.9715C11.8045 20.9898 12.1563 21 12.5001 21Z"
        fill={theme.colors.icon.resultButton}
      />
    </svg>
  )
}

export default HomeIcon
